<template>
    <div style="background:white; height:100%">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>我的任务</div> 
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>我的待跟进明细</div> 
            </div>
        </div> 
        <div v-show="actitem=='two'">
            <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
                <div style="padding-top:3px;display:flex;width:1400px; ">
                    <span style=" font-size:12px;margin-right:10px;font-weight:600;margin-left:5px">字段查询</span>
                    <el-select v-model="selparam2" size="small" placeholder="请选择列名" filterable  style="width:150px; " >
                        <span v-for="item in waitCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="getWaitList" size="small" style="width:320px; height:30px; ">
                        <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="getWaitList" ></el-button>
                    </el-input> 
                    <div style=" font-size:12px;margin-left:10px;margin-right:10px;font-weight:600;color:#389">状态</div>
                    <el-select v-model="v_wait" @change="getWaitList" size="small" placeholder="请选择" filterable  style="width:110px; " >
                        <el-option label="所有记录" value="ALL"  ></el-option>
                        <el-option label="待跟进" value="N"  ></el-option>
                        <el-option label="已跟进" value="Y"  ></el-option>
                    </el-select>
                </div>
            </div>
            <el-table  :data="waitData" 
                border                            
                size="small"
                :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                v-loading="w_loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                :height="subHeight" 
                :row-key="getWaitKey"
                ref="refwait"
                highlight-current-row
                header-cell-class-name="clearPadding"
                :header-cell-style="{ 'color':'#389','text-align':'center'}"
                class="custom-table-border"
                style="overflow:auto;margin-top:1px;"> 
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="wtShow" style="font-size:12px;color:#fff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1" style="color:#409eff"></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>    
                <el-table-column  v-for="(item ,index) in waitCol.filter(item=>item.thide=='N')" :key="index"  
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.sortable=='N'"
                    :min-width="item.width">
                    <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"   show-overflow-tooltip :min-width="item.width">
                        <template slot="header" slot-scope="scope">
                            {{scope.row}}
                            <el-date-picker v-if="item.edcss=='date'" @change="getWaitList" size="mini"  type="date" :clearable="false" v-model="v_wtrow[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                            <el-select v-else-if="item.edcss=='checkbox'" v-model="v_wtrow[item.key]"  size="mini" @change="getWaitList" placeholder="" clearable style="width:100%">
                                <el-option label="否" value="N"></el-option>
                                <el-option label="是" value="Y"></el-option>
                            </el-select>  
                            <el-input type="number" @keyup.enter.native="getWaitList" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" placeholder="" v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input>
                            <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="getWaitList"  v-model="v_wtrow[item.key]" size="mini" placeholder="" ></el-input>
                        </template>
                        <template slot-scope="scope">
                            <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>                         
                            <el-checkbox v-else-if="item.edcss=='checkbox'"   true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
 
                            <el-progress v-else-if="item.key=='PCT'" :text-inside="true" :stroke-width="20" :percentage="Number(scope.row['PCT'])"  style="color:red"></el-progress> 
                            <span v-else v-text="scope.row[item.key]" style="float:left"></span>
                        </template>
                    </el-table-column>
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="logRec(scope.row ,'WAIT')" :underline="false"  ><span style="font-size:12px;margin-right:10px;">跟进 </span></el-link>         
                    </template>
                </el-table-column>  
            </el-table>
            <!-- 分页查询 -->
            <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
                <div style="float: left;padding-left:4px;font-size:12px;">
                    <Page :total="wtCount" :page-size="rowSize" show-total :current="curwt" @on-change="waitChg"></Page>
                </div>
                <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                    <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                    <el-select v-model="rowSize" size="small" style="width:70px;"  @change="waitPage">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
        </div> 
        <div v-show="actitem=='one'">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;font-weight:600"></i>
                <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:13px;margin-right:15px;font-weight:600">新建项目</span></el-link>

                <span style=" font-size:12px;margin-right:10px;font-weight:600;margin-left:5px">字段查询</span>
                <el-select v-model="selparam" size="small" placeholder="请选择列名" filterable  style="width:150px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="inputQry" ></el-button>
                </el-input> 
                <!-- <el-button type="danger"   icon="iconfont icon-daochu" @click="copyData" size="mini" style="margin-left:15px;height:30px;margin-top:1px">导出当前资料</el-button> -->
                <div style=" font-size:12px;margin-right:10px;margin-left:15px;font-weight:600;color:#f00">与我相关</div>
                <el-checkbox @change="inputQry" size="larger" v-model="v_self" true-label="Y" false-label="N"  ></el-checkbox>
                <i v-if="v_see=='Y'" class="iconfont icon-pingpu" style="color:#389;margin-left:25px;margin-right:5px"></i>
                <i v-if="v_see=='N'" class="iconfont icon-liebiao2" style="color:#389;margin-left:25px;margin-right:5px"></i>
                
                <div style=" font-size:12px;margin-right:10px;font-weight:600;color:#389">模式</div>
                <el-select v-model="v_see" size="small" placeholder="请选择" filterable  style="width:110px; " >
                    <el-option label="平铺模式" value="Y"  ></el-option>
                    <el-option label="列表模式" value="N"  ></el-option>
                </el-select>
                <div style=" font-size:12px;margin-left:10px;margin-right:8px;font-weight:600; ">状态</div>
                <el-select @change="inputQry" size="small" v-model="v_stfg" placeholder="请选择" filterable clearable style="width:120px; " >
                    <el-option v-for="(item,index) in stfgArr" :key="index" :label="item['CNAME']" :value="item['CNAME']"  ></el-option>
                </el-select>
            </div>
        </div> 
        <div v-if="v_see=='Y'"  >
            <div class="project-container">
                <el-row :gutter="20">
                    <el-col v-for="(item, index) in oneData " :key="index" :xs="24" :sm="12" :md="8" :lg="8" :xl="6">
                        <div  class="project-card">
                            <div class="card-header">
                                <div class="project-title" :title="item.TASKNM">{{ item.TASKNM }}</div>
                                <div style="width:70px;text-align:center; ">
                                    <el-tag  v-if="item['STFG']=='未开始'" size="small" type="info" effect="dark">{{item['STFG']}}</el-tag>
                                    <el-tag  v-else-if="item['STFG']=='已终止'" size="small" type="danger" effect="dark">{{item['STFG']}}</el-tag>
                                    <el-tag  v-else-if="item['STFG']=='已逾期'" size="small" type="danger" effect="dark">{{item['STFG']}}</el-tag>
                                    <el-tag  v-else-if="item['STFG']=='已完成'" size="small" type="success" effect="dark">{{item['STFG']}}</el-tag>
                                    <el-tag  v-else size="small" type="warning" effect="dark">{{item['STFG']}}</el-tag>
                                </div>
                            </div>
                            <div class="card-body">
                                <p>项目类型：{{ item.ITEMTY }}</p >
                                <p>客户名称：{{ item.CLNTNM }}</p >
                                <p>立项日期：{{ item.DTTM }}</p >
                                <p>主负责人：{{ item.EMPNM }}</p >
                                <p>要求完成日期：{{ item.FINDTTM }}</p >
                            </div>
                            <div class="progress-section">
                                <el-progress :text-inside="true" text-color="#FFB6C1" :percentage="item.PCT" :stroke-width="22"></el-progress>
                                <p class="progress-info">
                                    <span style="font-weight:600;color:#808695">跟进人数：{{ item.EMPCNT }}人 | </span>
                                    编码：<el-link :underline="false"><span style="border-bottom:1px solid #f00">{{ item.IDNO }}</span></el-link>
                                    <span  >｜创建者：{{ item.ADDUSER }}</span>
                                </p >
                            </div>
                            <div class="card-footer">
                                
                                <div style="display:flex;">
                                    <el-button type="text" icon="iconfont icon-chakan" @click="editRec(item,'Y',index)" size="small" style="margin-right:8px">查看</el-button>
                                    <el-button type="text" icon="iconfont icon-yugutou1" @click="showChart(item )" size="small" style="margin-right:8px">轴线图</el-button>
                                    <el-button type="text" :disabled="editBool||item['ADDUSER']!==v_usernm" icon="iconfont icon-bianji" @click="editRec(item,'N',index)" size="small" style="margin-right:8px">编辑</el-button>
                                    <el-button type="text" :disabled="editBool " icon="iconfont icon-dengji" @click="logRec(item,'N')" size="small" style="margin-right:8px">跟进</el-button>
                                    <el-button type="text" :disabled="delBool||(item['ADDUSER']!==v_usernm &&v_admin=='N')" icon="iconfont icon-shanchu1" @click="stfgRec(item,'ONE', index)" size="small" style="margin-right:8px">删除</el-button>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div style="margin-top:2px;border-top:2px solid #808695;text-align:center; overflow:hidden;display:flex;background:white;font-size:12px">
                <div style="font-size:13px;font-weight:600;margin-left:8px;margin-top:2px;">
                    <Page :total="pCount" :page-size="psize" show-total :current="curpage" @on-change="nextPage"></Page>
                </div>
                <div style="line-height:30px;height:35px;width:500px;display:flex;margin-top:2px; ">
                    <div style="color:#606266; font-size:12px;width:35px;margin-left:15px;font-weight:600;">每页</div>
                    <el-select v-model="psize" size="small" style="width:70px;"  @change="onePage">
                        <el-option 
                            v-for="item in pageList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div> 
        <span v-if="v_see=='N'"> 
            <el-table  :data="itemData" 
                border                            
                size="small"
                :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                v-loading="t_loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                :height="subHeight" 
                :row-key="getRowKey"
                ref="refwork"
                highlight-current-row
                header-cell-class-name="clearPadding"
                :header-cell-style="{ 'color':'#389','text-align':'center'}"
                class="custom-table-border"
                style="overflow:auto;margin-top:1px;"> 
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#fff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1" style="color:#409eff"></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>    
                <el-table-column  v-for="(item ,index) in tabCol.filter(item=>item.thide=='N')" :key="index"  
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    :sortable="item.sortable=='N'"
                    :min-width="item.width">
                    <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"   show-overflow-tooltip :min-width="item.width">
                        <template slot="header" slot-scope="scope">
                            {{scope.row}}
                            <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                            <el-select v-else-if="item.edcss=='checkbox'" v-model="v_row[item.key]"  size="mini" @change="inputQry" placeholder="请选择"  clearable style="width:100%">
                                <el-option label="否" value="N"></el-option>
                                <el-option label="是" value="Y"></el-option>
                            </el-select>  
                            <el-input type="number" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  placeholder="数字框" v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                            <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                        </template>
                        <template slot-scope="scope">
                            <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:12px ">{{scope.row[item.key]}}</div> </el-link>                         
                            <el-checkbox v-else-if="item.edcss=='checkbox'"   true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <span v-else-if="item.key=='STFG'"> 
                                <el-tag  v-if="scope.row['STFG']=='未开始'" size="mini" type="info" effect="dark">{{scope.row['STFG']}}</el-tag>
                                <el-tag  v-else-if="scope.row['STFG']=='已终止'" size="mini" type="danger" effect="dark">{{scope.row['STFG']}}</el-tag>
                                <el-tag  v-else-if="scope.row['STFG']=='已逾期'" size="mini" type="danger" effect="dark">{{scope.row['STFG']}}</el-tag>
                                <el-tag  v-else-if="scope.row['STFG']=='已完成'" size="mini" type="success" effect="dark">{{scope.row['STFG']}}</el-tag>
                                <el-tag  v-else size="mini" type="warning" effect="dark">{{scope.row['STFG']}}</el-tag>
                            </span>
                            <el-progress v-else-if="item.key=='PCT'" :text-inside="true" :stroke-width="20" :percentage="Number(scope.row['PCT'])"  style="color:red"></el-progress> 
                            <span v-else v-text="scope.row[item.key]" style="float:left"></span>
                        </template>
                    </el-table-column>
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="175">
                    <template slot-scope="scope">
                        <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link @click="editRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:10px;">查看 </span></el-link>         
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="(scope.row['ADDUSER']!==v_usernm &&v_admin=='N') ||editBool" @click="editRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:10px;">编辑 </span></el-link>
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="(scope.row['ADDUSER']!==v_usernm &&v_admin=='N') ||delBool" @click="stfgRec(scope.row, 'X',scope.$index)" :underline="false"  ><span style="font-size:12px; ">删除</span></el-link>
                        
                    </template>
                </el-table-column>  
            </el-table>
            <!-- 分页查询 -->
            <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
                <div style="float: left;padding-left:4px;font-size:12px;">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                </div>
                <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                    <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                    <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
        </span>
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="bsRow" :label-width="110"   label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in tabCol" :key="index" >
                        <FormItem   :label="item.title"  :class="'row-width'" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="small" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="bsRow[item.key]" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                            <el-input  size="small" @focus="inputBtn( item.key)"  v-else-if="item.edcss=='button'"   v-model="bsRow[item.key]" style="width:100%;border:1px solid #f7f8f9"> </el-input>  
                            <el-input-number size="small" :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="bsRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-checkbox size="small"  border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="bsRow[item.key]" style="width:100%"></el-checkbox> 
                            <el-select  size="small" @change="selChg" v-else-if="item.edcss==='select'" v-model="bsRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                            </el-select>
                            <el-input size="small"  :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="bsRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-div"> <span class="oneRow"> 工作分配明细 </span>
                    <el-button :disabled="addBool||saveFlag"  @click="saveRec" type="primary" plain size="mini" style="height:25px;margin-top:2px;margin-left:20px;border:1px solid green">
                        <i class="iconfont icon-baocun" style=" font-size:12px;margin-right:3px"></i>保存表头资料
                    </el-button> 
                    <el-button :disabled="addBool||saveFlag"  @click="dtlAdd('','ROOT')" type="danger" plain size="mini" style="height:25px;margin-top:2px;margin-left:40px;border:1px solid #389">
                        <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px"></i>新增根节点明细
                    </el-button> 
                    
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    disabled-hover
                    v-loading="v_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    style="overflow:auto;margin-top:-9px;"
                    size="small"
                    :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
                    :height="dtlHeight"              
                    ref="refdtl" 
                    :row-key="getDtlKey"
                    :header-cell-style="{ 'background':'#389','color':'white'}"
                    default-expand-all
                    :tree-props="{children: 'children', hasChildren: 'hasChildren'}" 
                    class="custom-table-border"
                    highlight-current-row>
                <el-table-column label="序号" type="index" width="55"></el-table-column>
                <el-table-column label="工作内容" prop="wknm" :min-width="200" :show-overflow-tooltip="true" align="left">

                </el-table-column>
                <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N'&&item.key!=='wknm')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    :show-overflow-tooltip="true"
                    :align="item.align"                                
                    :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot-scope="scope">
                        <el-link @click="attView(scope.row)" v-if="item.key=='isatt' && scope.row[item.key]=='Y'" :underline="false"><span style="border-bottom:1px solid red;font-size:11px">附件</span></el-link>  
                        <el-progress v-else-if="item.key=='pct'" :text-inside="true" :stroke-width="24" :percentage="Number(scope.row['pct'])"  style="color:red"></el-progress>                            
                        <el-tag  v-else-if="item.key=='stfg'&&scope.row[item.key]=='N'" size="mini" type="info" effect="dark">待跟进</el-tag>
                        <el-tag  v-else-if="item.key=='stfg'&&scope.row[item.key]=='Y'" size="mini" type="success" effect="dark">已跟进</el-tag>
                        <el-link  v-else-if="item.key=='wknm'" :underline="false" >
                            <!-- <div style="float:left;font-size:12px;width:100%;color:black; "> -->
                                {{scope.row[item.key]}}
                            <!-- </div> -->
                        </el-link> 
                        <div v-else v-text="item.key=='isatt'?'':scope.row[item.key]" style="float:left"> </div>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="245">
                    <template slot-scope="scope">
                        <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link   @click="dtlAdd(scope.row,'SUB' )" :underline="false"  ><span style="font-size:12px;margin-right:8px;">新增子节点 </span></el-link>
                        <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link   @click="editDtl(scope.row,scope.$index,'Y')" :underline="false"  ><span style="font-size:12px;margin-right:8px;">查看 </span></el-link>
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="editDtl(scope.row,scope.$index,'N')" :underline="false"  ><span style="font-size:12px;margin-right:8px;">编辑 </span></el-link>
                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px; "></i>
                        <el-link :disabled="delBool" @click="delRec(scope.row,scope.$index )" :underline="false" ><span style="font-size:12px; ">删除</span></el-link>
                    </template>
                </el-table-column>                      
            </el-table>
            </div>

        </el-dialog>

        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag v-if="btnWin"  :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog> 
        <el-dialog  v-dialogDrag v-if="mulWin"  :visible.sync="mulWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-multi v-bind:tabCol ="tableCol" v-bind:v_cond="t_cond" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="mulWin=false" @child-sure="mulSure"></pub-multi>                
        </el-dialog> 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- 增加任务明细 -->
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="taskWin" width="900px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">任务明细</span>
            </div>
            <div style="height:80vh;overflow-y:auto">
                <div  class="one-div">
                    <span class="oneRow"> 基本信息 </span> 
                </div>
                <Form :model="formRow" :label-width="120"  label-position="right" inline  :rules="dtlValidate">  
                    <div v-for="(item,index) in dtlCol" :key="index" style=" line-height:45px">
                        <FormItem  :label="item.title"   :class="item.edcss=='textarea'?'item-width2':'item-width'" :prop="item.key2"  v-if="item.fhide==='N'">                  
                            <!-- <el-select :disabled ="dtlFlag" @change="selClear('REFIDTY')"  v-if="item.key2=='REFIDTY' " v-model="formRow[item.key2]"  placeholder="请选择"  clearable size="medium" style="width:100% ">
                                <span v-for="(item,index) in tyArr" :key='index' >
                                    <el-option :label="item.CNAME" :value="item.CNAME" ></el-option>
                                </span>
                            </el-select> -->
                            <el-select :disabled ="dtlFlag" @change="selClear('WKTY')"  v-if="item.key2=='WKTY' " v-model="formRow[item.key2]"  placeholder="请选择"  clearable size="medium" style="width:100% ">
                                <span v-for="(item,index) in wktyArr" :key='index' >
                                    <el-option :label="item.CNAME" :value="item.CNAME" ></el-option>
                                </span>
                            </el-select>
                            <el-input size="medium" readonly   v-else-if="item.key2=='REFIDTY' " v-model="formRow[item.key2]" style="width:100%"> 
                                <template slot="suffix" > <el-link   @click="mulBtn('REFIDTY')" :underline="false" style="margin-top:3px" ><i class="iconfont icon-icon-choose" style="color:red" ></i></el-link></template>
                            </el-input> 
                            <el-input-number :disabled ="dtlFlag"  :min="0" :max="100" v-else-if="item.key2=='PCT' " size="medium" v-model="formRow[item.key2]" style="width:100%"> </el-input-number> 
                            <el-checkbox size="medium" border v-else-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formRow[item.key2]" style="width:100%"></el-checkbox> 
                            <el-date-picker :disabled ="dtlFlag" type="date" size="medium" v-else-if="item.edcss==='date'" v-model="formRow[item.key2]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  

                            <el-input type="textarea" :rows="3" resize="none" v-model="formRow[item.key2]" placeholder="请输入" v-else-if="item.edcss=='textarea'" style="width:100%"></el-input>
                            <el-input :disabled ="dtlFlag" clearable  @focus="inputBtn(item.key2)"   v-else-if="item.edcss=='button'" size="medium" v-model="formRow[item.key2]" style="width:100%;border:1px solid #389"> </el-input>  
                            <el-input size="medium" type="text" v-else :disabled="item.disabled==='Y'?true:false||dtlFlag "  v-model="formRow[item.key2]"></el-input>
                        </FormItem>
                    </div>
                </Form>
                <div  class="one-div">
                    <span class="oneRow"> 附件明细 </span> 
                </div>
                <div style="display:flex" >
                    <Upload
                        :disabled="dtlFlag"
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :max-size="204800"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :with-credentials="true"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex;margin-right:30px;flex-wrap:wrap"  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:200px;height:180px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:200px;height:180px;margin-right:30px;" :src="item.FILEPATH"/> 
                            <div style="width:200px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                <span style="font-weight:600;font-size:12px;color:red"> 文件名：</span>{{item.FILENM}}
                            </div>
                            <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                <el-link :disabled="dtlFlag" :underline="false" @click="imgDel(item ,index,'NORMAL')"><Icon type="md-close" /> 删除</el-link> 
                                <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />查看</el-link>
                                <el-link v-else :underline="false" style="margin-right:5px;" @click="downFile(item.FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="taskWin=false" size="small"  icon="iconfont icon-shanchu" style="margin-left:50px;">  取消</el-button>
                    <el-button :disabled="dtlFlag ||v_isok" @click="cfmRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-chenggong1"  > 保存</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog class="pub_dialog" v-if="guWin" v-dialogDrag  :visible.sync="guWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">节点图示</span>
            </div> 
            <div style="overflow:auto;height:85vh"> 
                <fish-win v-bind:apiData="v_apiData" v-bind:v_root="v_root"></fish-win> 
            </div>
        </el-dialog>
        <el-dialog class="pub_dialog" v-if="orgWin" v-dialogDrag  :visible.sync="orgWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">节点图示</span>
            </div> 
            <div  class="one-div" style="margin-top:-8px">                    
                <span class="oneRow" style="display:flex"> 
                    <!-- <div style="margin-right:5px; margin-left:3px;font-weight:600;font-size:12px">显示方向 :</div>
                    <el-radio-group v-model="v_orient" size="small"  @change="toggleOrg">
                        <el-radio label="横排"   style="font-weight:600;font-size:12px;margin-top:8px;margin-left:8px"></el-radio>
                        <el-radio label="竖排"  style="font-weight:600;font-size:12px;margin-top:8px"></el-radio>
                    </el-radio-group> -->
                    <div style="margin-left:5px;font-weight:600;font-size:13px;color:black;display:flex">
                        提示：任务节点逾期时 边框为<div style="background:red;width:23px;height:23px;margin-left:5px;margin-top:2px;margin-right:5px"></div>
                        与自己相关的任务节点 边框为
                        <div style="background:#409eff;width:23px;height:23px;margin-left:5px;margin-top:2px"></div>
                    </div>
                </span> 
            </div>
            <div style="overflow:auto;height:85vh"  > 
                <split-pane  :min-percent='30' :default-percent='70' split="vertical">
                    <template slot="paneL">
                        <div style="width:100%;height:100%;min-width:0;min-height:0;overflow:auto;">
                            <org-tree
                                :data="orgData"
                                :horizontal="!horizontal"
                                :collapsable="false"                
                                :render-content="renderContent"
                                name="orgtree"
                                @on-node-click="onNodeClick"
                            ></org-tree>
                        </div>
                    </template>
                    <template slot="paneR">   
                        <div v-if="selectedNodeId!=='1'" style="background-color:#fff; ">
                            <div v-for="(item, index) in taskData " :key="index"  >
                                <div  style="border-radius:6px;padding: 4px;background:#f7f8f9;min-width:160px;border:1px solid #ccc;height:300px;overflow-y:auto ">
                                    <div class="card-line" style="display:flex" v-for="(it,ind) in taskCol.filter(item=>item.fhide=='N')" :key="ind">
                                        <div style="width:120px; flex-shrink:0;font-weight:600;font-size:12px;color:#808695">{{it.title}}： </div> 
                                        <div style="min-width:130px; flex-grow:1;">
                                            <div v-if="it.key=='REFATTACH'" style="display:flex">
                                                <div v-for="(item,index) in imgData" :key="index" style="margin-right:5px">  
                                                    <div style="min-width:60px;height:25px;border-bottom:1px solid #f00;max-width:120px ">
                                                        <el-link  :underline="false" style="margin-right:10px;" @click="attShow(item.FILEPATH)">
                                                            <div style="text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:120px "> {{item.FILENM}}</div>
                                                        </el-link>
                                                    </div>
                                                </div>
                                            </div>
                                            <el-progress v-else-if="it.key=='PCT'" :stroke-width="12" style="min-width:130px;margin-top:4px" :percentage="item['PCT']"></el-progress>
                                            <div v-else-if="it.key=='EMPNM2'" :title="item[it.key]+ item['SCORENM']" style="min-width:130px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap; font-weight:600;font-size:13px;color:black">{{ item[it.key] }}
                                               <span style="color:red;font-weight:600"> {{ item['SCORENM'] }} </span>
                                            </div>
                                            <div v-else style="min-width:130px; font-weight:600;font-size:13px;color:black">{{ item[it.key] }} </div>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                            <div  class="one-div" style="margin-top:2px">
                                <span class="oneRow"> 跟进详情 </span> 
                                <el-button :disabled="addBool "  @click="logAdd" type="danger" plain size="mini" style="height:25px;margin-top:2px;margin-left:40px;border:1px solid #389">
                                    <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px"></i>新增记录
                                </el-button> 
                                <el-button :disabled="editBool "  @click="logEdit" type="primary" plain size="mini" style="height:25px;margin-top:2px;margin-left:40px;border:1px solid #389">
                                    <i class="iconfont icon-bianji" style=" font-size:12px;margin-right:3px"></i>设置进度
                                </el-button> 
                                <el-button :disabled="editBool||v_admin=='N' "  @click="fenEdit" type="warning" plain size="mini" style="height:25px;margin-top:2px;margin-left:40px;border:1px solid #389">
                                    <i class="iconfont icon-shoudongtongbu" style=" font-size:12px;margin-right:3px"></i>评分
                                </el-button> 
                            </div>
                            <div :style="{'overflow-y':'auto', 'height':logHeight}">
                                <el-timeline style="margin-top:10px;margin-left:15px">
                                    <el-timeline-item v-for="(item, index) in logData" 
                                            :key="index"
                                            :color="item.COLOR"
                                            size="large"                                                
                                            style="margin-left:3px"
                                            placement="top">                                     
                                        <!-- 自定义方框节点 -->
                                        <template #dot>
                                            <div class="custom-timeline-dot">
                                                <div class="dot-text"> {{ item.MTHDAY }} </div>
                                            </div>
                                        </template>
                                        <div style="margin-left:10px;padding:4px;margin-top:-10px">新增日期：{{item.ADDDTTM}} </div>
                                        <div  style="border-radius:8px;margin-left:10px;padding:4px;background:#f7f8f9;min-width:160px;border:1px solid #ccc ">
                                            <div class="card-line">{{item.LOGRMK}}</div>                  
                                            <div class="card-footer">   
                                                <span>跟进日期：{{item.DTTM}}  |  跟进用户：{{item.ADDUSER}}</span>                                                                                 
                                            </div>
                                            <div v-if="item['PHODATA'] && item['PHODATA'].length>0" style="font-size: 14px;color: #555;line-height: 28px;margin-left:6px;min-width:200px;display:flex">
                                                <div v-for="(it,ind) in item['PHODATA']" :key="ind" style="margin-right:5px">  
                                                    <div :title="it.FILENM" style="min-width:60px;height:26px;border-bottom:1px solid #f00;color:black;max-width:120px ">                                                            
                                                        <el-link  :underline="false"  @click="attShow(it.FILEPATH)">
                                                            <div style="text-overflow:ellipsis;overflow: hidden;white-space:nowrap;max-width:120px ">
                                                                {{it.FILENM}}
                                                            </div>
                                                        </el-link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-footer">                                    
                                                <div style="display:flex;">
                                                    <el-button type="text" :disabled="item['ADDUSER']!==v_usernm" icon="iconfont icon-bianji" @click="editLog(item,index )" size="small" style="margin-right:8px">编辑</el-button>
                                                    <el-button type="text" :disabled="item['ADDUSER']!==v_usernm" icon="iconfont icon-shanchu1" @click="cutLog(item,index )" size="small" style="margin-right:8px">删除</el-button>
                                                </div>
                                            </div> 
                                        </div>
                                    </el-timeline-item>      
                                </el-timeline> 
                            </div>
                        </div> 
                        <div v-if="selectedNodeId=='1'" style="background-color:#fff; ">      
                            <div  style="border-radius:6px;padding: 4px;background:#f7f8f9;min-width:160px;border:1px solid #ccc;height:300px;overflow-y:auto ">
                                <div class="card-line" style="display:flex" v-for="(it,ind) in tabCol.filter(item=>item.fhide=='N')" :key="ind">
                                    <div style="width:130px; font-weight:600;font-size:12px;color:#808695">{{it.title}}： </div> 
                                    <el-progress v-if="it.key=='PCT'" :stroke-width="12" style="min-width:130px;margin-top:4px" :percentage="v_logRow['PCT']"></el-progress>
                                    <div v-else style="min-width:130px; font-weight:600;font-size:13px;color:black">{{ v_logRow[it.key] }} </div>
                                </div>
                            </div>                
                            <div  class="one-div" style="margin-top:2px">
                                <span class="oneRow"> 当前项目附件明细 </span> 
                                <el-button :disabled="editBool "  @click="taskEdit" type="warning" plain size="mini" style="height:25px;margin-top:2px;margin-left:40px;border:1px solid #389">
                                    <i class="iconfont icon-bianji" style=" font-size:12px;margin-right:3px"></i>设置项目进度
                                </el-button> 
                            </div>
                            <div :style="{'overflow-y':'auto', 'height':logHeight}">
                                <el-timeline style="margin-top:10px;margin-left:15px">
                                    <el-timeline-item v-for="(item, index) in rootData" 
                                            :key="index"
                                            size="large"                                                
                                            style="margin-left:3px"
                                            placement="top">                                     
                                        <!-- 自定义方框节点 -->
                                        <template #dot>
                                            <div class="custom-timeline-dot">
                                                <div class="dot-text"> {{ item.MTHDAY }} </div>
                                            </div>
                                        </template>
                                        <div style="margin-left:10px;padding:4px;margin-top:-10px">上传日期：{{item.ADDDTTM}} </div>
                                        <div  style="border-radius:8px;margin-left:10px;padding:4px;background:#f7f8f9;min-width:160px;border:1px solid #ccc ">
                                            <div class="div-line">
                                                <div style="display:flex;line-height:30px;height:30px">文档名称：<el-link :underline="false" @click="attShow(item.FILEPATH)"><span style="border-bottom:1px solid red">{{ item.FILENM }}</span></el-link></div >
                                                <div style="display:flex;line-height:30px;height:30px">审批状态： 
                                                    <span v-if="item.STFG=='Y' ">
                                                        <el-tag   size="small" type="success" effect="dark">已审核</el-tag>
                                                    </span>
                                                    <span v-else-if="item.STFG=='P' ">
                                                        <div >
                                                            <i class="iconfont icon-shenhezhong" style="font-size:22px;color:808695"></i>                                                  
                                                        </div>
                                                    </span>
                                                    <span v-else>                                                        
                                                        <!-- <el-tag  size="small" type="danger" effect="dark">未审核</el-tag> -->
                                                        <div >
                                                            <i class="iconfont icon-weishenhe3" style="font-size:22px;color:red"></i>                                                  
                                                            <!-- <el-button v-if="item.STFG=='N'" style="margin-left:15px" type="text" size="small" icon="iconfont icon-faqi">发起审批</el-button> -->
                                                        </div>
                                                    </span>
                                                </div >
                                                <div style="display:flex;line-height:30px;height:30px">上传用户：{{ item.ADDUSER }}</div >
                                            </div>
                                        </div>
                                    </el-timeline-item>      
                                </el-timeline> 
                            </div>
                        </div>
                    </template>
                </split-pane>
            </div>
        </el-dialog>
        <!-- 增加任务行日志 -->
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="logWin" width="900px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">跟进明细</span>
            </div>
            <div style="height:80vh;overflow-y:auto">
                <div  class="one-div">
                    <span class="oneRow"> 基本信息 </span> 
                </div>
                <Form :model="logRow" :label-width="120"  label-position="right" inline :rules="logValidate">  
                    <div v-for="(item,index) in logCol" :key="index" style=" line-height:45px">
                        <FormItem  style="width:98%" :label="item.title" :prop="item.key"  v-if="item.fhide==='N'">                  
                            <el-input type="textarea" :rows="6"  v-model="logRow[item.key]" placeholder="请输入" v-if="item.edcss=='textarea'" style="width:100%"></el-input>
                            <el-date-picker  type="date" size="medium" v-else-if="item.edcss==='date'" v-model="logRow[item.key]" :clearable="false" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>  
                            <el-input size="medium" type="text" v-else :disabled="item.disabled==='Y'?true:false"  v-model="logRow[item.key]" style="width:100%"></el-input>
                        </FormItem>
                    </div>
                </Form>
                <div  class="one-div">
                    <span class="oneRow"> 上传附件明细 </span> 
                </div>
                <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="okImgFile"
                        :max-size="204800"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :with-credentials="true"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex;margin-right:30px;flex-wrap:wrap"  >
                        <span v-for="(item,index) in phoData" :key="index">  
                            <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:200px;height:180px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image :preview-src-list="[item.FILEPATH]"   v-else   style="width:200px;height:180px;margin-right:30px;" :src="item.FILEPATH"/> 
                            <div style="width:200px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                <span style="font-weight:600;font-size:12px;color:red"> 文件名：</span>{{item.FILENM}}
                            </div>
                            <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                                <el-link  :underline="false" @click="imgDel(item ,index,'LOG')"><Icon type="md-close" /> 删除</el-link> 
                                <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />查看</el-link>
                                <el-link v-else :underline="false" style="margin-right:5px;" @click="downFile(item.FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="logWin=false" size="small"  icon="iconfont icon-shanchu" style="margin-left:50px;">  取消</el-button>
                    <el-button  @click="logSave" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-chenggong1"  > 保存</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="pctWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:40px;display:flex">
                <div style="width:100px; ">完成进度% </div>
                <el-input-number v-model="v_pct" :min="1" :max="100"  size="medium" style="width:100%; "></el-input-number>
            </div>
            <div style="line-height:40px;display:flex;margin-top:20px;margin-bottom:15px">
                <div style="width:100px; ">任务状态 </div>
                <el-select size="medium" v-model="t_stfg" placeholder="请选择" filterable  style="width:100%; " >
                    <el-option v-for="(item,index) in stfgArr" :key="index" :label="item['CNAME']" :value="item['CNAME']"  ></el-option>
                </el-select>
            </div>
            <div style="line-height:40px;display:flex;margin-top:20px;margin-bottom:15px">
                <div style="width:100px; ">备注 </div>
                <el-input  v-model="t_rmk"   size="medium" style="width:100%; "></el-input> 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="pctWin=false" size="small"  icon="iconfont icon-shanchu" style="margin-left:50px;">  取消</el-button>
                    <el-button  @click="pctSave" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-chenggong1"  > 保存</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog :show-close="false" v-dialogDrag :visible.sync="fenWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:40px;display:flex">
                <div style="width:100px; ">任务得分 </div>
                <el-input-number v-model="v_score" :min="1" :max="100"  size="medium" style="width:100%; "></el-input-number>
            </div>
            <div style="line-height:40px;display:flex;margin-top:20px;margin-bottom:15px">
                <div style="width:100px; ">评分备注 </div>
                <el-input  v-model="v_rmk"   size="medium" style="width:100%; "></el-input> 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="fenWin=false" size="small"  icon="iconfont icon-shanchu" style="margin-left:50px;">  取消</el-button>
                    <el-button  @click="fenSave" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-chenggong1"  > 保存</el-button>
                </span>
            </div>
        </el-dialog>
        </div>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate, getDate2} from '../../api/Select' 
import fishWin from  '../datamgt/gantTmpl.vue'
import pubWin from '../datamgt/pubwin.vue'  
import pubMulti from '../datamgt/pub_easy_multi.vue'  
import FileSaver from 'file-saver' 
import repWin from '../datamgt/repWin.vue' 
//import listItem from './tree_work_two.vue'
import {upperJSONKey,isNull} from '../../api/user'
import { Row } from 'iview';
export default {
    name:'tree_work_one',
    data () {
        return {
            mulWin:false,
            v_score:10,  
            v_rmk:'',          
            fenWin:false,
            pctWin:false,
            v_pct:10,
            v_stfg:'',
            t_stfg:'',
            v_orient:'横排',
            horizontal: false,
            orgData:[],
            logWin:false,
            logRow:{},
            logCol:[],
            logData:[],
            v_admin:this.$cookies.get('v_admin') , 
            orgWin:false,
            v_apiData:[],
            v_root:'',
            guWin:false,
            v_cond:'',
            t_cond:'',
            saleWin:false,
            toolFlag:false,
            loadWin:false,
            taskWin:false,
            v_wtrow:{},
            v_see:'Y',
            stfgBool:true,
            btnWin:false,
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            dtlValidate:{},
            logValidate:{},
            formRow:{},
            notNull:[],
            promptWin:false,
            v_random:'',
            prdRow:{},
            v_sel:'N',
            wkCol: [],
            empCol:[],
            frmCol:[],
            v_self:'N',
            cltCol:[],
            v_row:{},
            delDtlArr:[],
            prompt:'',
            t_rmk:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            actitem:'one',
            selparam:'TASKNM',
            txtparam:'',
            selparam2:'TASKNM',
            oper2:'like',
            txtparam2:'',
            v_isok:false,
            bsRow:{},
            tyArr: [],
            goPage:'',
            phoData:[],
            itemData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //删除权限
            t_loading:false,
            current:1,
            curwt:1,
            saveFlag:false,
            dtlFlag:false,
            allList:[], //询价单集合
            v_loading:false,
            dtlData:[],
            delBool:false,
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
            v_formurl:'xuper_auth/getTableRecMany',
            options: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            dataCount:0,
            wtCount:0,
            rowSize:50,
            psize:20,
            pCount:0,
            curpage:1,
            pageList: [ {
                value: 20,
                label: '20'
                },{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            oneData:[],
            dtlCol:[],
            waitCol:[],
            matCol:[],
            tabCol:[],
            operArr:[],
            poCol:[],
            ordCol:[],
            newCol:[],
            oper:'like',
            wktyArr:[],
            taskCol:[],
            delImg:[],
            delLogImg:[],
            comboArr:[],
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            taskData:[],
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            repWin:false,
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            v_key:'',
            chkIndex:'',
            showData:[],
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            imgData:[],
            fileName:'',
            selectedNodeId:null,
            logNull:[],
            itemNull:[],
            stfgArr:[],
            v_itemty:'',
            v_logRow:{},
            rootData:[],
            v_wait:'N',
            allWait:[],
            w_loading:false,
            waitData:[],
        }
    },
    components: {
      fishWin,  //注册组件
      pubWin,
      pubMulti,
      repWin,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 190) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 316) + 'px';
        }, 
        logHeight: function() {
            return (window.innerHeight - 495) + 'px';
        },
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        },
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    mounted () {
        this.showkey()
        getBaseData(this.v_formurl+'','userno',this.v_username,'frmidseq','17437','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData(this.v_url,'PARENTNO','462299','','','v_sys_base','').then(res=>{
            this.stfgArr =res.result
        })
        //工作类型
        getBaseData(this.v_url,'PARENTNO','461229','','','v_sys_base','').then(res=>{
            this.wktyArr =res.result
        }) 
        getBaseData('xuper_auth/getBaseData','parentno','228812','subno2','WORK','v_SYS_BASE','').then(res=>{
            this.tyArr =res.result
        })
        //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','17437','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //删除
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','17437','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','17437','LSTSEQ','3','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.itemNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.dtlValidate =ruleObj
        })
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','17437','LSTSEQ','6','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.logNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.logValidate =ruleObj
        })
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getTabList('')  
            this.comSelect() 
            this.getWaitList()
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
 
        //切换方向  
        toggleOrg(){
            this.horizontal = !this.horizontal
        },
        buildTree(list,v_root) {
            const map = {}
            list.forEach(item => {
                map[item.CODE] = {
                    idseq:item['IDSEQ'],
                    lstseq:item['LSTSEQ'],
                    self:item['EMPNM2']==this.v_usernm?'Y':'N',
                    over:item['ISOVER'],
                    id: item.CODE,
                    pct: item.PCT,
                    label: item.WKNM,  // 任务名
                    EMPNM2: item.EMPNM2 || '', // 负责人
                    FINDTTM:item.FINDTTM,
                    children: []
                }
            })
            const roots = []
            list.forEach(item => {
                if (item.PARENTNO && item.PARENTNO !== '#') {
                    const parent = map[item.PARENTNO]
                    if (parent) {
                        parent.children.push(map[item.CODE])
                    } else {
                        roots.push(map[item.CODE])
                    }
                } else {
                    roots.push(map[item.CODE])
                }
            })

            return {
                id: '1',
                label: v_root,
                EMPNM2:  this.v_logRow['ADDUSER'],
                pct: this.v_logRow['PCT'],
                children: roots
            }
        },
        logAdd(){
            if (this.selectedNodeId=='1'){
                this.promptWin =true
                this.prompt ='根节点下不能操作'
            }else{
                let v_obj =this.taskData[0]
                let v_empnm =v_obj['EMPNM2']
                let v_idseq=v_obj['IDSEQ']
                let v_lstseq=v_obj['LSTSEQ']
                if (v_empnm==this.v_usernm){
                    this.logWin =true
                    this.phoData =[]
                    this.logRow ={'DTTM':getDate('day'),STFG:'进行中',IDSEQ:v_idseq,LSTSEQ:'', REFLSTSEQ:v_lstseq}
                }else{
                    this.promptWin =true
                    this.prompt ='当前任务的负责人与当前账号不匹配，不能操作'
                }
            }
        },
        logEdit(){
            if (this.selectedNodeId=='1'){
                this.promptWin =true
                this.prompt ='根节点下不能操作'
            }else{
                this.v_random='LOG'
                let v_obj =this.taskData[0]
                let v_empnm =v_obj['EMPNM2']
                if (v_empnm==this.v_usernm){
                    this.pctWin =true
                    this.v_pct =v_obj['PCT']
                }else{
                    this.promptWin =true
                    this.prompt ='当前任务的负责人与当前账号不匹配，不能操作'
                }
            }
        },
        getWaitList(){
            //待跟进
            let cond_=' and empnm2=\''+this.v_usernm+'\''
            if (this.selparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                }
            }
            //状态
            if (this.v_wait =='N'){
                cond_ =cond_ + ' and pct<100 ' 
            }else if (this.v_wait =='Y'){
                cond_ =cond_ + ' and pct =100 ' 
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_wtrow).forEach(item=>{
                if (this.v_wtrow[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_wtrow[item] 
                        }else{
                            v_cond =v_cond +' and  '+item+' like \'%'+ (this.v_wtrow[item]).trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_wtrow[item] 
                        }else{
                            v_cond = ' and  '+item+'  like \'%'+ (this.v_wtrow[item]).trim()+'%\''
                        }
                    }
                }
            })
            this.w_loading =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_cond:cond_ +v_cond+' order by findttm',p_key:'corpid',p_value:this.v_corpid,p_table:'V_bs_taskDTL'},
            }).then(res=>{    
                this.allWait =res.result
                this.waitPage() 
                this.w_loading=false
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refwait.doLayout()
                }) 
            })
        },
        fenEdit(){
            let v_obj =this.taskData[0]
            this.v_score = v_obj['SCORE'] ||10
            this.v_rmk =v_obj['CHKRMK']
            this.fenWin =true
        },
        taskEdit(){
            let v_empnm =this.v_logRow['ADDUSER']
            if (v_empnm==this.v_usernm|| this.v_admin=='Y'){
                this.v_random='TASK'
                this.pctWin =true
                this.v_pct =this.v_logRow['PCT']
                this.t_stfg =this.v_logRow['STFG']
            }else{
                this.promptWin =true
                this.prompt ='当前任务的负责人与当前账号不匹配，不能操作'
            }
        },
        pctSave(){
            if (this.v_pct && this.t_stfg){    
                let v_rmk=''
                if (this.t_rmk){
                    v_rmk =this.t_rmk
                }            
                let v_cond=' set pct='+this.v_pct+',stfg=\''+this.t_stfg+'\',rmk=\''+v_rmk+'\',upduser=\''+this.v_usernm+'\',upddttm=\''+getDate('full')+'\'' 
                if (this.v_random =='LOG'){
                    let v_obj =this.taskData[0]
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:v_obj.IDSEQ,p_key2:'lstseq',p_value2:v_obj.LSTSEQ,p_table:'bs_taskdtl',p_cond:v_cond},
                    }).then(res=>{  
                        this.pctWin =false
                        this.taskData[0]['PCT'] =this.v_pct
                        this.taskData[0]['RMK'] =v_rmk
                        //重新查询
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/getBaseData',
                            data: {p_key:'idseq',p_value:v_obj['IDSEQ'],p_table:'V_bs_taskDTL' },
                        }).then(res=>{    
                            this.orgData =this.buildTree(res.result,this.v_itemty)
                        })
                    }) 
                }else{ //项目根节点
                    this.$axios({
                        method: 'post',
                        url: 'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:this.v_logRow['IDSEQ'], p_table:'bs_task',p_cond:v_cond},
                    }).then(res=>{  
                        this.pctWin =false
                        this.v_logRow['PCT'] =this.v_pct
                        this.v_logRow['STFG'] =this.t_stfg
                        this.v_logRow['RMK'] =v_rmk
                        //重新查询
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/getBaseData',
                            data: {p_key:'idseq',p_value:this.v_logRow['IDSEQ'],p_table:'V_bs_taskDTL' },
                        }).then(res=>{    
                            this.orgData =this.buildTree(res.result,this.v_itemty)
                        })
                    }) 
                }
            }else{
                this.promptWin =true
                this.prompt ='进度百分比或状态不能为空'
            }
        },
        //评分保存
        fenSave(){
            if (this.v_score){
                let v_dttm =getDate('full')
                let v_rmk =''
                if (this.v_rmk){
                    v_rmk =this.v_rmk
                }
                let v_cond=' set score='+this.v_score+',chkrmk=\''+v_rmk+'\',chkuser=\''+this.v_usernm+'\',chkdttm=\''+v_dttm+'\''
                let v_obj =this.taskData[0]
                this.$axios({
                    method: 'post',
                    url: 'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:v_obj['IDSEQ'],p_key2:'lstseq',p_value2:v_obj['LSTSEQ'],p_table:'bs_taskdtl',p_cond:v_cond},
                }).then(res=>{  
                    this.fenWin =false
                    this.taskData[0]['SCORE'] =this.v_score
                    this.taskData[0]['CHKRMK'] =this.v_rmk
                    this.taskData[0]['CHKUSER'] =this.v_usernm
                    this.taskData[0]['CHKDTTM'] =v_dttm
                }) 
            }else{
                this.promptWin =true
                this.prompt ='分数不能为空'
            }
        },
        // --- 点击事件 ---
        onNodeClick(e, data) {
            this.selectedNodeId = data.id     
            this.taskData=[]        
            this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:data.idseq,p_key2:'lstseq',p_value2:data.lstseq,p_table:'v_bs_taskdtl'},
            }).then(res=>{ 
                this.taskData =res.result
                //查询节点的附件
                this.qryImgData(data.idseq,data.lstseq)
                //查询跟进内容
                this.getLogList(data.idseq,data.lstseq)
                if (this.selectedNodeId =='1'){
                    this.getAttach(this.v_logRow['IDSEQ'])
                }
            })
        },
        // --- 自定义节点渲染 ---
        renderContent(h, data) {
            const isTarget = data.EMPNM2 === '#'
            const isSelected = data.id === this.selectedNodeId // ✅ 是否选中
            const style = {
                backgroundColor: isSelected ? '#ccc' : isTarget ? '#808695' : '', // 高亮选中优先
                color: isSelected  ? 'black' : '',
                padding: '8px 10px',
                margin: '-10px -18px',
                display: 'inline-block',
                borderRadius: '4px',
                cursor: 'pointer',
                border: data.self=='Y'?'2px solid #409eff':data.over=='Y'?'2px solid red': '' ,
            }
            if (data.id=='1'){
                return (                    
                    <div style={style}>
                        <span >{data.label}</span>
                        {data.EMPNM2 ? <div style="margin-left: 6px;">创建者：({data.EMPNM2}) </div> : ''}
                        <div style={{ marginTop: '2px' }} >
                            <el-progress
                                percentage={data.pct} // 初始化值
                                onInput={(val) => {
                                    this.$set(data, 'id', val)
                                }}
                            ></el-progress>
                        </div>
                    </div>    
                )
            }else{
                return (                    
                    <div style={style}>
                        <div style="text-align:left;line-height:22px"> {data.label} 
                        {data.EMPNM2 ? <span style="margin-left:4px;">({data.EMPNM2}) </span> : ''}</div>
                        <div style="text-align:left;line-height:22px;color:black;font-weight:600">要求完成期 :{data.FINDTTM}</div>
                        <div style="line-height:22px;text-align:left;display:flex" >进度% :
                            <el-progress
                                percentage={data.pct} // 初始化值
                                style="width:110px;margin-left:8px;font-size:13px;margin-top:2px"
                                stroke-width={14}
                            ></el-progress>
                        </div>
                    </div>    
                )
            }
        },
        selChg(val){          
            if (val=='未开始'){
                this.bsRow['PCT'] =0
            }else if (val =='已完成'){
                this.bsRow['PCT'] =100
            }else{
                this.bsRow['PCT'] =20
            }
       
        },
        //查询图片数据        
        qryImgData(idseq,lstseq){
            this.imgData =[]
            console.log(idseq,lstseq)
            getTabColOrData(this.v_formurl,'v_mat_img','idseq',idseq,'filety','IMG','REFLSTSEQ',lstseq).then((res) => {
                if (res){
                    this.imgData =res.result
                }
            })
        },
        beforeImgFile (res, file) {
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false           
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            }else if (res.code=='201'){ // 文件哈希值存在的情况下
                this.imgData.push({FILEPATH: res.filepath,FILENM:file.name,FILETY:'IMG',PATH:'',REFIDSEQ:res.idseq,REFLSTSEQ:res.lstseq})                   
            }else{
                this.promptWin =true
                this.prompt =res.result
            }                  
        },
        okImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false           
            if (res.code=='200'){
                this.phoData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            }else if (res.code=='201'){ // 文件哈希值存在的情况下
                this.phoData.push({FILEPATH: res.filepath,FILENM:file.name,FILETY:'IMG',PATH:'',REFIDSEQ:res.idseq,REFLSTSEQ:res.lstseq})                   
            }else{
                this.promptWin =true
                this.prompt =res.result
            }                  
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出20M' 
        },
        //附件删除，操作数组
        imgDel(item,index,val){
            if(item['IDSEQ'] && item['LSTSEQ']){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'refidseq',p_value:item['IDSEQ'],p_key2:'reflstseq',p_value2:item['LSTSEQ'],p_table:'V_MAT_IMG'},
                }).then(res=>{  
                    if(res.result.length>0 && res.result){
                        this.promptWin =true
                        this.prompt ='此附件已存在引用，不能删除'
                    }else{
                        this.$confirm('你确定要删除此附件吗','提示',{
                            confirmButtonText: '确定',
                            cancelButtonText:'取消',
                            customClass:'messageBox',
                            showClose:false,
                            closeOnClickModal:false,
                            closeOnPressEscape:false,
                            type:'info',
                        }).then(()=>{                            
                            if (val =='LOG'){
                                this.delLogImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                                this.phoData.splice(index, 1);   
                            }else{
                                this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                                this.imgData.splice(index, 1)
                            }
                        }).catch(()=>{})
                    }
                })
            }else{
                this.$confirm('你确定要删除此附件吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    if (val =='LOG'){
                        this.delLogImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                        this.phoData.splice(index, 1);   
                    }else{
                        this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                        this.imgData.splice(index, 1)
                    } 
                }).catch(()=>{})
            }
        },
        downFile(filePath){
            const arr_name=filePath.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(filePath,file_name) 
        },
        clrBtn( key){
          if (key =='EMPNM') { 
             this.formRow['EMPNM'] =''
          } 
        },
        //删除记录
        delRec(row,index){           
            let v_cond=  ' and parentno=\''+ row['lstseq'] +'\''
            this.$axios({
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:row['idseq'],p_cond:v_cond,p_table:'V_bs_taskdtl'},
            }).then(res=>{ 
                if (res.result.length>0 && res.result){
                    this.promptWin =true
                    this.prompt ='已存在子节点，不能删除，若要删除，请先删除已存在的子节点'
                }else{
                    this.$confirm('你确定要删除此节点吗','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row['idseq'],p_key2:'lstseq',p_value2:row['lstseq'], p_table:'bs_taskdtl'},
                        }).then(res=>{ 
                            this.getDtlList(row['idseq'])
                        })
                    }).catch(()=>{})
                } 
            })
        },
        //附件点击事件
        attShow(filePath){
            if (filePath.toLowerCase().lastIndexOf('.pdf')>-1){ //pdf
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl:filePath},
                });
                window.open(routeUrl.href, '_blank')
            }else{
                const arr_name=filePath.split("/")
                const file_name=arr_name[arr_name.length-1] //获取文件名
                FileSaver.saveAs(filePath,file_name) 
            }
        },
        //预览PDF
        pdfShow(filepath){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl:filepath},
            });
            window.open(routeUrl.href, '_blank');
        },
        selClear(key){
            if (key =='WKTY'){  //工作类型
                this.formRow ['ITEMTY']=''
                this.formRow ['SRC']=''
                this.formRow ['OUTPUT']=''
            }else if (key =='REFIDTY'){  //工作类型
                this.formRow ['REFIDNO']=''
            }
        },
        copyData(){
            //导出
            this.loadWin =true   
            this.$axios({
                method: 'post',
                url:'xuper_auth/report/GenExcel',
                data: {p_idseq:'17437',p_lstseq:'1',p_json:JSON.stringify(this.allList),p_action:'项目列表'},
                responseType:'blob' //关键，声明响应类型为二进制流
            }).then(response=>{ 
                // 从响应头解析后端设置的文件名
                // 创建Blob对象并触发下载  创建下载链接
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob)
                link.download = '项目列表_'+getDate('full')+'.xls'
                link.click()
                URL.revokeObjectURL(link.href)
                this.loadWin =false
            }) 
        },
 
        itemClick(val){
            this.actitem =val     
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getTabList('')
        } ,
        wtShow(){
            Object.keys(this.v_wtrow).forEach(item=>{
                this.v_wtrow[item] =''
            })
            this.getWaitList('')
        } ,
        
        //字段查询
        inputQry(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
            //与我相关
            if (this.v_self =='Y'){
                cond_ =cond_ +' and idseq in (select idseq from bs_taskdtl where empnm2=\''+this.v_usernm+'\')'
            }
            if (this.v_stfg ){
                cond_ =cond_ + ' and stfg=\''+this.v_stfg+'\''
            }
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and  '+item+' like \'%'+ (this.v_row[item]).trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                        }
                    }
                }
            })
            this.getTabList(v_cond+cond_)
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        mulSure(obj){
            if (obj.length>0){
                this.formRow['REFIDTY']=obj.map(item=>item['FRMNM']).join(',')
                this.formRow['REFIDTYNM']=obj.map(item=>item['IDSEQ']).join(',')
            }
            this.mulWin=false
        },
        btnSure(obj){
            if (this.v_key =='EMPNM2'){
                this.formRow['EMPNM2'] =obj['EMPNM']
                this.formRow['EMPIDSEQ'] =obj['IDSEQ']
            }else if (this.v_key =='EMPNM'){
                this.bsRow['EMPNM'] =obj['EMPNM']
            }else if (this.v_key =='CLNTNM'){
                this.bsRow['CLNTNM'] =obj['CLNTNM']
            }else if (this.v_key =='ITEMTY'){
                this.formRow['ITEMTY'] =obj['JOBNM']
                this.formRow['SRC'] =obj['SRC']
                this.formRow['OUTPUT'] =obj['OUTPUT']
            }else if (this.v_key =='REFIDNO'){
                this.formRow['REFIDNO'] =obj['IDNO']
            }
            this.btnWin =false
        },
        mulBtn(key){
            this.tableCol =this.frmCol
            this.v_table ='v_sys_form'               
            this.v_key2 =''
            this.v_value2 =''
            this.t_cond=' and frmurl is not null'
            this.mulWin =true
        },
        inputBtn(key){
            this.v_key =key    
            if (key =='EMPNM'||key=='EMPNM2'){ //负责人
                this.tableCol =this.empCol
                this.v_table ='v_HR_EMP'               
                this.v_key2 ='STFG'
                this.v_value2 ='Y'
                this.btnWin =true
            }else if (key =='CLNTNM'){ //负责人
                this.tableCol =this.cltCol
                this.v_table ='v_bs_clnt'               
                this.v_key2 =''
                this.v_value2 =''
                this.btnWin =true
            }else if (key =='ITEMTY'){ //类型下项目
                this.tableCol =this.wkCol
                this.v_table ='V_BS_LIBITM'               
                this.v_key2 ='TYNM'
                this.v_value2 =this.formRow['WKTY']  //工作类型
                this.btnWin =true
            }else if (key =='REFIDNO'){
                if (this.formRow['REFIDTY']=='采购订单') { //采购订单
                    //this.v_key ='采购订单'  
                    this.v_table ='v_po_ord'
                    this.tableCol =this.poCol
                    this.v_key2 =''
                    this.v_value2 =''
                    this.btnWin =true
                }else if (this.formRow['REFIDTY']=='销售订单') { //销售订单
                    //this.v_key ='销售订单' 
                    this.v_table ='v_ord'
                    this.tableCol =this.ordCol
                    this.v_key2 =''
                    this.v_value2 =''
                    this.btnWin =true
                }else if (this.formRow['REFIDTY']=='开发建议书') { //开发建议书
                    //this.v_key ='开发建议书' 
                    this.v_table ='v_RD_MAT'
                    this.tableCol =this.newCol
                    this.v_key2 =''
                    this.v_value2 =''
                    this.btnWin =true
                } 
            }  
            
        },
 
        dtlAdd(row,val){
            if (this.bsRow['IDNO']){
                this.taskWin =true
                this.v_isok=false
                this.imgData=[]
                if (val =='ROOT'){
                    this.formRow={PARENTNO:'#'}
                }else{
                    this.formRow={PARENTNO:row['lstseq']}                     
                }
            }else{
                this.promptWin =true
                this.prompt ='单据编码为空时 请先保存表头资料'
            }
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
         
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
               
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
 
        //明细 
        getDtlList(idseq ){
            this.v_loading =true
            this.dtlData=[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getPlanTreeData',
                data: {p_key:'idseq',p_value:idseq,p_table:'V_bs_taskDTL',p_cond: ' order by lstseq' },
            }).then(res=>{ 
                this.dtlData =res.result 
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                    this.v_loading =false
                })  
            })
        },
        getLogList(idseq,lstseq ){
            this.logData=[]
            this.loadWin =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:idseq,p_key2:'reflstseq',p_value2:lstseq,p_table:'V_BS_TASKDTL_LOG',p_cond:' order by dttm desc,adddttm desc' },
            }).then(res=>{ 
                this.logData =res.result 
                // 在每行记录上 加上 日志附件
                this.logData.forEach((item,index) =>{
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: {p_key:'idseq',p_value:item['IDSEQ'],p_key2:'reflstseq',p_value2:item['LSTSEQ'],p_table:'V_MAT_IMG',p_cond:' order by lstseq' },
                    }).then(res2=>{
                        this.logData.splice(index,1,Object.assign(item,{PHODATA:res2.result}))
                    })
                })
                this.loadWin=false
            })
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'17437',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //跟进
        logRec(item,val){
            this.v_itemty =val=='WAIT'?item['TASKTY']:item['ITEMTY']
            this.loadWin =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:item['IDSEQ'],p_table:'V_bs_taskDTL',p_cond:' order by lstseq' },
            }).then(res=>{    
                this.selectedNodeId='1' 
                if (val =='WAIT'){
                    this.$axios({   
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: {p_key:'idseq',p_value:item['IDSEQ'],p_table:'V_bs_task' },
                    }).then(res2=>{    
                        this.v_logRow =res2.result[0]     
                    })
                } else{ 
                    this.v_logRow =JSON.parse(JSON.stringify(item))
                }                
                this.orgData =this.buildTree(res.result,this.v_itemty )
                this.orgWin =true
                this.taskData=[]
                this.logData=[]
                this.getAttach(item['IDSEQ']) 
                this.loadWin =false
            })
        },
        getAttach(v_idseq){
            this.rootData =[]
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:v_idseq,p_table:'V_BS_TASK_IMG',p_cond:' order by adddttm desc' },
            }).then(res=>{             
                this.rootData =res.result
            })
        },
        showChart(item){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'idseq',p_value:item['IDSEQ'],p_table:'V_bs_taskDTL',p_cond:' order by lstseq' },
            }).then(res=>{ 
                this.v_root = item['ITEMTY']                 
                this.v_apiData =res.result
                this.guWin =true
            })
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row['ADDUSER']==this.v_usernm){
                    this.saveFlag=false
                }else{
                    this.saveFlag=true
                }
            }
            this.bsRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
 
            //明细
            this.getDtlList(row.IDSEQ)
            this.addWin=true   
        },
        editLog(row, index){
            this.logRow =Object.assign(JSON.parse(JSON.stringify(row)),{PHODATA:''})
             
            //明细附件
            this.getPhoList(row.IDSEQ,row['LSTSEQ'])
            this.logWin=true   
        },
        getPhoList(idseq,lstseq){
            this.phoData =[]
            getTabColOrData(this.v_formurl,'v_mat_img','idseq',idseq,'filety','IMG','REFLSTSEQ',lstseq).then((res) => {
                if (res){
                    this.phoData =res.result
                }
            })
        },
        editDtl(row, index,val){
            if (val==='Y'){  //仅查看
                this.dtlFlag=true
            }else{
                this.dtlFlag=false
            }
 
            this.formRow ={LSTSEQ:row['lstseq'],WKNM:isNull(row['wknm']),EMPNM2:isNull(row['empnm2']),FINDTTM:isNull(row['findttm']),WKTY:isNull(row['wkty']),
                            ITEMTY:isNull(row['itemty']),SRC:isNull(row['src']),OUTPUT:isNull(row['output']),REFIDTY:isNull(row['refidty']),REFIDNO:isNull(row['refidno']),
                            RMK:isNull(row['rmk'])
            }
            //明细附件
            this.qryImgData(row.idseq,row['lstseq'])
            this.taskWin=true   
          
        },
        cfmRec(){            
            this.itemNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            if (this.stfgBool ){
                this.v_isok=true
                //明细要保存起来，有图片
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/tableBodySave',
                    data: {p_json:JSON.stringify(this.formRow), p_table:'bs_taskdtl',p_idseq:this.bsRow['IDSEQ']},
                }).then(res=>{
                    if (res.code!=='200'){
                        this.v_isok=false
                        this.promptWin=true
                        this.prompt=res.result
                    }else{
                        let v_lstseq=res.idseq
                        //2、图片保存
                        for(var k=0;k<this.imgData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k],{REFLSTSEQ:v_lstseq } )), p_table:'mat_img',p_idseq:this.bsRow['IDSEQ']},
                            })
                        } 
                        //图片删除处理
                        for(let k=0;k<this.delImg.length;k++){
                            let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                            }).then(res=>{      
                                if(res.code !=='200')  {  
                                    this.prompt=res.message
                                    this.promptWin=true
                                }else{                          
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{ 
                                            //console.log(res.result)
                                        })
                                    }
                                }        
                            })        
                        }
                        this.v_isok=false
                        this.taskWin=false
                        this.getDtlList(this.bsRow['IDSEQ'])
                    }
                })
            }
        },
        //日志保存
        logSave(){            
            this.logNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.logRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            if (this.stfgBool ){
                this.logWin=false
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/tableBodySave',
                    data: {p_json:JSON.stringify(this.logRow), p_table:'BS_TASKDTL_LOG',p_idseq:''},
                }).then(res=>{
                    if (res.code!=='200'){
                        this.promptWin=true
                        this.prompt=res.result
                    }else{
                        let v_lstseq=res.idseq
                        //2、图片保存
                        for(var k=0;k<this.phoData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.phoData[k],{REFLSTSEQ:v_lstseq,IDSEQ:this.logRow['IDSEQ'] } )), p_table:'mat_img',p_idseq:this.logRow['IDSEQ']},
                            })
                        } 
                        //图片删除处理
                        for(let k=0;k<this.delLogImg.length;k++){
                            let v_filepath=this.delLogImg[k]['FILEPATH'],v_path=this.delLogImg[k]['PATH']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delLogImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delLogImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delLogImg[k]['FILEPATH'],p_table:'mat_img'},
                            }).then(res=>{      
                                if(res.code !=='200')  {  
                                    this.prompt=res.message
                                    this.promptWin=true
                                }else{                          
                                    //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                    if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                        this.$axios({
                                            method: 'post',
                                            url: '/xuper_oss/ftpDelete',
                                            data: {p_path:'/volume1'+v_path},
                                        }).then(res=>{ 
                                            //console.log(res.result)
                                        })
                                    }
                                }        
                            })        
                        }
                        //
                        this.getLogList(this.logRow['IDSEQ'],this.logRow['REFLSTSEQ'])
                    }
                })
            }
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.bsRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool ){
                let v_title='' 
                if (v_title){
                    this.promptWin =true
                    this.prompt =v_title +'不能为空'
                } else{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.bsRow,{CORPID:this.v_corpid })), p_table:'bs_task',frmid:'17437'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/getBaseData',
                                data: { p_table:'V_bs_task' ,p_key:'idseq',p_value: idseq_ },
                            }).then(res=>{
                                this.bsRow=res.result[0]
                                this.$message({message: '已保存！', type: 'success', center:true,offset: window.innerHeight / 2 })
                            })     
                            this.inputQry()
                     
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    })  
                }
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.bsRow={DTTM:getDate('day'),'IDSEQ':'',STFG:'未开始' }
            this.dtlData=[]
            this.saveFlag=false
 
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getWaitKey(row){
            return row.IDSEQ+'-'+row.LSTSEQ
        },
        getDtlKey(row){
            return row['idseq']+'-'+row['lstseq']
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        
        //状态变更
        stfgRec(row,val, index){        
            let v_cond =' set stfg=\'X\' '      
            this.$confirm('你确定要删除此记录吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'bs_task',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  { 
                        if (val=='ONE'){
                            this.oneData.splice(index,1)             
                        }else{
                           this.itemData.splice(index,1)    
                        }
                    }else{
                        this.prompt=res.result
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})
        },
        cutLog(row, index){           
            this.$confirm('你确定要删除此记录吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_table:'BS_TASKDTL_LOG'},
                }).then(res=>{      
                    if(res.code =='200')  { 
                        this.logData.splice(index,1)
                    }else{
                        this.prompt=res.result
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})
        },
 
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.itemData = this.allList.slice(_start,_end);
        },
        nextPage(index){
            var _start = ( index - 1 ) * this.psize;
            var _end = index * this.psize
            this.curpage =index
            this.oneData = this.allList.slice(_start,_end);
        },
        waitChg(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.curwt  =index
            this.waitData = this.allWait.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.itemData = this.allList          
            }else{
       
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.itemData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            
        },
        onePage(){
            this.pCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.psize){
                this.oneData = this.allList          
            }else{
                this.oneData =this.allList.slice(0,this.psize) //返回选定元素的子数组，不包含结尾元素
            }            
        },
        waitPage(){
            this.wtCount =this.allWait.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allWait.length < this.rowSize){
                this.waitData = this.allWait          
            }else{
                this.waitData =this.allWait.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }            
        },
        // 
        getTabList(cond){
            let vm =this
            this.t_loading=true
            getTabColOrData(vm.v_formurl,'V_bs_task','','','CORPID',this.v_corpid,'','',cond+' order by ADDDTTM desc' ).then((res) => { 
                this.allList =res.result 
                this.initPage() 
                this.onePage()
                this.t_loading=false
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    if (this.v_see =='N'){
                        this.$refs.refwork.doLayout()
                    }
                }) 
            })
        },
  
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','17437','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','17437','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.empCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                        notnull:res.result[k].NOTNULL, 
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','17437','lstseq','9','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.frmCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                        notnull:res.result[k].NOTNULL, 
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','17437','lstseq','4','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.wkCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                        notnull:res.result[k].NOTNULL, 
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','17437','lstseq','3','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key.toLowerCase(),
                        key2: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                        notnull:res.result[k].NOTNULL, 
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','17437','lstseq','5','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.taskCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        key2: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','17437','lstseq','6','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.logCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        notnull:res.result[k].NOTNULL,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','108','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.poCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','123','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.ordCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','417247','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.newCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','94','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.cltCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','17437','lstseq','7','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.waitCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key ,
                        key2: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                        notnull:res.result[k].NOTNULL, 
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .custom-timeline-dot {
        width: 42px;   /* 方框宽度（根据需要调整） */
        height: 40px;  /* 方框高度（根据需要调整） */
        border: 2px solid green;
        color: green;
        border-radius: 6px; /* 方角圆润 */
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
 
        font-weight: 700;
        font-size: 14px;
        transform: translateX(-16px);
    }
    /* 日期文字内缩、防止换行 */
    .custom-timeline-dot .dot-text {
        line-height: 1;
        white-space: nowrap;
    }
    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .row-width{
        width:32%;
        height:16px !important;

    }
    .item-width  {
        width: 98%;
        color:#409EFF;
        height: 18px !important;
    }
    .item-width2  {
        width: 98%;
        height:60px !important;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .project-container {
        padding: 10px;
        background: #f5f7fa;
        height: calc(100vh - 186px);
        //min-height: 85vh;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .project-container .el-col {
        margin-bottom: 10px;  
    }
    .project-card {
        border-radius: 10px;
        padding: 4px;
        background:white;
    }

    .project-card:hover {
        background: rgb(218, 217, 221);
        //border:1px solid rgb(92, 88, 88);
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        margin-top:8px;
    }

    .project-title {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        padding-left: 2px;
        text-overflow:ellipsis;
        overflow: hidden;
        white-space:nowrap;
        border-left:4px solid green;
    }

    .card-body {
        font-size: 14px;
        color: #555;
        line-height: 28px;
        margin-left: 3px;
        text-overflow:ellipsis;
        overflow: hidden;
        white-space:nowrap;
    }
    .card-line {
        font-size: 14px;
        color: #555;
        line-height: 28px;
        margin-left: 3px;
        min-width:200px;
    }
    .progress-section {
        margin-top: 5px;
        margin-left: 3px;
    }

    .progress-info {
        font-size: 13px;
        color: #666;
        margin-top: 6px;
        margin-left: 3px;
    }

    .card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        font-size: 13px;
        color: #888;
        margin-top: 5px;
        margin-left: 3px;
    }

    /* 小屏幕优化 */
    @media screen and (max-width: 768px) {
        .project-card {
            padding: 0px;
        }
        .project-title {
            font-size: 16px;
        }
    }
    .div-line {
        font-size: 13px;
        color: #555;
        line-height: 24px;
        margin-left: 3px;
        text-overflow:ellipsis;
        overflow: hidden;
        white-space:nowrap;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
    .el-icon-arrow-right {
        color:#ff0000;
    }
    .el-table .el-table__expand-icon{
        .el-icon-arrow-right:before{
            content: '\e791';
        }
    }
 
</style>
